import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ModalButton from "./ModalButton";
import { Link } from "react-router-dom";

const images = [
  "./images/business-signs-toowoomba-QLD.webp",
  "./images/illuminated-entrance-signs-toowoomba.webp",
  "./images/illuminated-signage-toowoomba.webp",
  "./images/painted-building-signage-toowoomba.webp",
  "./images/pylon-signs-toowoomba.webp",
  "./images/structural-LED-pylon-signage-toowoomba.webp",
];

export default function Hero(props) {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    // Preload images
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    // Change active image every 5 seconds
    const interval = setInterval(() => {
      setActiveImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container
      fluid
      className="hero-section p-5 text-center rounded-3 d-flex flex-column align-items-center"
    >
      {images.map((img, index) => (
        <div
          key={img}
          className={`background-image ${
            activeImageIndex === index ? "active" : ""
          }`}
          style={{
            backgroundImage: `
                        linear-gradient(rgba(12, 19, 31, 0.5), rgba(12, 19, 31, 0.6)),
                        radial-gradient(ellipse at left top, rgba(12, 19, 31, 0.6) 0%, transparent 80%),
                        radial-gradient(ellipse at right bottom, rgba(12, 140, 233, 1) 0%, transparent 80%),
                        url(${img})
                        `,
          }}
        ></div>
      ))}

      <div className="hero-card d-flex flex-column justify-content-center align-items-center">
        <div className="header-logo d-flex justify-content-center align-items-center">
          <img
            src="./images/logo.png"
            className="brand-image brand-image-mobile"
            alt="logo"
          />
          <h1 className="brand-name">
            Toowoomba <b className="bold-word">Sign</b> Co
          </h1>
        </div>
        <div className="hero-headings">
          <Row className="justify-content-start">
            <Col xs={12} className="text-white text-center">
              <h2 className="mb-3 hero-title">
                <Link to="/" className="text-white">
                  Signs Toowoomba
                </Link>{" "}
                – Custom Signage &{" "}
                <Link to="/" className="text-white">
                  Sign Writers Toowoomba
                </Link>
              </h2>
              <p className="mb-3 hero-subheading">
                At Toowoomba Sign Co, we provide expert signage solutions in
                Toowoomba. From shopfront signage and 3D illuminated signs to
                vehicle wraps and retail displays, our local team designs,
                manufactures, and installs high-quality signs that help your
                business stand out.
              </p>
              <p className="mb-3 hero-subheading hero-subheading-mobile">
                Serving Toowoomba, the Darling Downs & throughout QLD we deliver
                signage that not only looks professional but also drives
                customer engagement.
              </p>
              {props.isHomePage && <ModalButton />}
              <div style={{ textAlign: "center" }}>{props.children}</div>
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}
